import { useEffect } from 'react';

export function useHotjarPosition(disabled = false) {
  useEffect(() => {
    const applyStyles = (el: HTMLElement | null, styles: Record<string, string>) => {
      if (!el) return;
      for (const [prop, val] of Object.entries(styles)) {
        if (el.style.getPropertyValue(prop) !== val) {
          el.style.setProperty(prop, val, 'important');
        }
      }
    };

    let isApplying = false;

    const fix = (container: Element) => {
      if (isApplying) return;
      isApplying = true;

      if (disabled) {
        applyStyles(container as HTMLElement, { display: 'none' });
        isApplying = false;
        return;
      }

      applyStyles(container as HTMLElement, {
        display: '',
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        right: 'auto',
        top: 'auto',
        'z-index': '999999',
      });

      applyStyles(container.querySelector('[id^="hj-survey-toggle"]') as HTMLElement, {
        right: 'auto',
        left: '15px',
        bottom: '110px',
      });

      applyStyles(container.querySelector('[role="dialog"]') as HTMLElement, {
        bottom: '60px',
        left: '100px',
        right: 'auto',
        top: 'auto',
        'transform-origin': 'bottom left',
      });

      applyStyles(container.querySelector('[class^="css-"]') as HTMLElement, {
        right: 'auto',
        left: '90px',
        bottom: '15px',
        top: 'auto',
      });

      // Reveal after positioning is applied (hidden by default in index.css)
      applyStyles(container as HTMLElement, { visibility: 'visible' });

      isApplying = false;
    };

    let containerObserver: MutationObserver | null = null;
    let wiredUp = false;

    const wireContainer = (container: Element) => {
      if (wiredUp) return;
      wiredUp = true;

      fix(container);

      containerObserver = new MutationObserver(() => fix(container));
      containerObserver.observe(container, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['style', 'class'],
      });

      bodyObserver.disconnect();
    };

    const bodyObserver = new MutationObserver(() => {
      const container = document.querySelector('._hj-widget-container');
      if (container) wireContainer(container);
    });

    const startObserving = () => {
      bodyObserver.observe(document.body, { childList: true, subtree: true });

      const existing = document.querySelector('._hj-widget-container');
      if (existing) wireContainer(existing);
    };

    if (document.readyState === 'complete') {
      startObserving();
    } else {
      window.addEventListener('load', startObserving);
    }

    return () => {
      window.removeEventListener('load', startObserving);
      bodyObserver.disconnect();
      containerObserver?.disconnect();
    };
  }, [disabled]);
}
